import {
	type GOALS_GQL_FIELD,
	GOALS_CF_TYPE,
} from '@atlassian/jira-platform-field-config/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { AggTransformerFunction } from '../types/transformer-type.tsx';
import { transformAggNodeToLegacyField } from './default-node-transformer.tsx';

interface Goal {
	id: string;
	name: string;
	status: string | null | undefined;
	url?: string;
	key?: string;
}

export const transformAggGoalsToLegacyField: AggTransformerFunction<typeof GOALS_GQL_FIELD> = (
	node,
) => {
	if (node.type !== GOALS_CF_TYPE) return undefined;

	// eslint-disable-next-line jira/ff/no-preconditioning
	const isShowAllGoals = fg('goals_field_with_gpp_in_issue_view') && fg('jira-glance-panel');
	const activeSelectedGoals = isShowAllGoals ? node.selectedGoalsShowAllGoals : node.selectedGoals;

	const value = activeSelectedGoals
		? {
				goals:
					activeSelectedGoals?.edges
						?.filter((edge) => edge?.node !== null)
						.map((edge) => {
							const transformedNode = edge?.node;
							const result: Goal = {
								id: transformedNode?.id || '',
								name: transformedNode?.name || '',
								status: transformedNode?.status || null,
							};

							// Include key for multi-goal case (key field is only available in selectedGoalsShowAllGoals)
							if (isShowAllGoals && transformedNode) {
								// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
								const nodeWithKey = transformedNode as Goal;
								if (nodeWithKey.key) {
									result.key = nodeWithKey.key;
								}
							}

							return result;
						}) || [],
				totalCount: activeSelectedGoals?.totalCount || 0,
			}
		: null;

	return {
		...transformAggNodeToLegacyField(node),
		value,
		schema: {
			configuration: null,
			custom: GOALS_CF_TYPE,
			items: null,
			renderer: null,
			system: null,
			type: GOALS_CF_TYPE,
		},
	};
};
